module.exports = __webpack_public_path__ + "img/24.580d38a1.png";